export default __webpack_public_path__ + "static/media/dustin.e9c9e3d7.jpeg";